import React from 'react';
import { RouterProvider } from 'react-router-dom';
import router from '@link/metro-24h/routes';

const App: React.FC = () => {
  return <RouterProvider router={router} />;
};

export default App;
